import React from "react";
import { Button, ButtonGroup, Dropdown, Form, Row } from "react-bootstrap";
import moment from "moment";
import OutsideClickHandler from "react-outside-click-handler";
import Calendar from "react-calendar";
import { Utils } from "../../../Common/Utilis";

const formatDate = (value: any = false, selectedDate) => {
  value = value?.toString()?.replace(/[^0-9\/]+/gi, "");
  const formmatedDate = Utils.AddSlashINInputDateFormat(
    value,
    selectedDate,
    true,
    2,
    false
  );

  if (formmatedDate === "invalid") {
    return;
  } else {
    return formmatedDate;
  }
};

const oneYearBack = () => {
  let d = new Date();
  d.setFullYear(d.getFullYear() - 1);
  return d;
};
const minDateDefault = oneYearBack();
export class DailyActivityCalendarSelector extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      currentIndex: -1,
      calenderShow: false,
      selectedDate: "",
      minimumDate: "",
    };
  }

  calenderHide = () => {
    if (this.state.selectedDate.length !== 8) {
      const { defaultValue, onChange } = this.props;
      const value = defaultValue
        ? moment(defaultValue).format("MM/DD/YY")
        : moment().subtract(1, "days").format("MM/DD/YY");
      this.setState({ calenderShow: false, selectedDate: value }, () => {
        onChange(value);
      });
    } else {
      this.setState({ calenderShow: false });
    }
  };

  calenderDisplay = () => {
    this.setState({ calenderShow: true });
  };

  componentDidMount() {
    const { defaultValue, minDate } = this.props;

    this.setState({ minimumDate: minDate ? minDate : minDateDefault }, () => {
      const value = defaultValue
        ? moment(defaultValue).format("MM/DD/YY")
        : moment().subtract(1, "days").format("MM/DD/YY");
      this.setSelectedDate(value);
    });
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.defaultValue != this.props.defaultValue) {
      const { defaultValue, onChange } = this.props;
      const value = defaultValue
        ? moment(defaultValue).format("MM/DD/YY")
        : moment().subtract(1, "days").format("MM/DD/YY");
      this.setSelectedDateOnParentChange(value);
    }
  };

  setSelectedDateOnParentChange = (value) => {
    const formmattedDate = formatDate(value, this.state.selectedDate);
    const minDateFormatted = moment(this.state.minimumDate).format("MM/DD/YY");
    const maxDateFormatted = this.props?.maxDate
      ? this.props?.maxDate
      : moment().subtract(1, "days").format("MM/DD/YYYYY");
    if (!formmattedDate) return;

    this.setState({
      selectedDate: formmattedDate,
    });
  };

  setSelectedDate = (value) => {
    const { onChange } = this.props;

    const formmattedDate = formatDate(value, this.state.selectedDate);
    const minDateFormatted = moment(this.state.minimumDate).format("MM/DD/YY");
    const maxDateFormatted = this.props?.maxDate
      ? this.props?.maxDate
      : moment().subtract(1, "days").format("MM/DD/YYYYY");
    if (!formmattedDate) return;

    // if (formmattedDate?.length === 8) {
    //   if (
    //     !moment(minDateFormatted)?.isSameOrBefore(formmattedDate) ||
    //     !moment(maxDateFormatted)?.isSameOrAfter(formmattedDate)
    //   ) {
    //     return;
    //   }
    // }
    this.setState(
      {
        selectedDate: formmattedDate,
      },
      () => {
        onChange(formmattedDate);
      }
    );
  };

  handleDateChange = (event, _inputPosition, isBlur = false) => {
    let value = event.target.value;

    const _formattedDate = Utils.AddSlashINInputDateFormat(
      value,
      this.state.selectedDate,
      true,
      2,
      isBlur
    );
    if (_formattedDate === "invalid") {
      return;
    } else {
      value = _formattedDate;
    }
    const { onChange } = this.props;
    const { selectedDate } = this.state;
    const minDateFormatted = moment(this.state.minimumDate).format("MM/DD/YY");

    // if (value.length === 8) {
    //   if (
    //     !moment(minDateFormatted)?.isSameOrBefore(value) ||
    //     !moment(new Date())?.isSameOrAfter(value)
    //   ) {
    //     return;
    //   }
    // }

    this.setState(
      {
        selectedDate: value,
      },
      () => {
        onChange(value);
      }
    );
  };

  handleNextDate = () => {
    const { selectedDate } = this.state;
    const value = moment(selectedDate).add(1, "days").format("MM/DD/YY");
    this.setSelectedDate(value);
  };

  handlePreviousDate = () => {
    const { selectedDate } = this.state;
    const value = moment(selectedDate).subtract(1, "days").format("MM/DD/YY");
    this.setSelectedDate(value);
  };

  render() {
    const { currentIndex, calenderShow, selectedDate } = this.state;
    const { isDateFetching } = this.props;

    return (
      <div
        className={`${
          isDateFetching
            ? "disabled day-year-picker d-flex"
            : "day-year-picker d-flex"
        }`}
      >
        {/* <label>Date</label> */}

        <button
          className="btn arrow-left-btn"
          onClick={this.handlePreviousDate}
        >
          <svg
            width="6"
            height="9"
            viewBox="0 0 6 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.98314 8.414L0.879001 4.207L4.98314 0L6 1.04235L2.91273 4.207L6 7.37165L4.98314 8.414Z"
              fill="#1D1E20"
            />
          </svg>
        </button>

        <button className="btn input-container">
          <div className="calender-container" onClick={this.calenderDisplay}>
            <div
              className={
                calenderShow ? "calender-display open" : "calender-display"
              }
            >
              <div className="calender-icn">

                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_3974_21253)">
                    <path d="M4.16667 18.3337C3.70833 18.3337 3.31597 18.1705 2.98958 17.8441C2.66319 17.5177 2.5 17.1253 2.5 16.667V5.00033C2.5 4.54199 2.66319 4.14963 2.98958 3.82324C3.31597 3.49685 3.70833 3.33366 4.16667 3.33366H5V1.66699H6.66667V3.33366H13.3333V1.66699H15V3.33366H15.8333C16.2917 3.33366 16.684 3.49685 17.0104 3.82324C17.3368 4.14963 17.5 4.54199 17.5 5.00033V16.667C17.5 17.1253 17.3368 17.5177 17.0104 17.8441C16.684 18.1705 16.2917 18.3337 15.8333 18.3337H4.16667ZM4.16667 16.667H15.8333V8.33366H4.16667V16.667ZM4.16667 6.66699H15.8333V5.00033H4.16667V6.66699ZM10 11.667C9.76389 11.667 9.56597 11.5871 9.40625 11.4274C9.24653 11.2677 9.16667 11.0698 9.16667 10.8337C9.16667 10.5975 9.24653 10.3996 9.40625 10.2399C9.56597 10.0802 9.76389 10.0003 10 10.0003C10.2361 10.0003 10.434 10.0802 10.5938 10.2399C10.7535 10.3996 10.8333 10.5975 10.8333 10.8337C10.8333 11.0698 10.7535 11.2677 10.5938 11.4274C10.434 11.5871 10.2361 11.667 10 11.667ZM6.66667 11.667C6.43056 11.667 6.23264 11.5871 6.07292 11.4274C5.91319 11.2677 5.83333 11.0698 5.83333 10.8337C5.83333 10.5975 5.91319 10.3996 6.07292 10.2399C6.23264 10.0802 6.43056 10.0003 6.66667 10.0003C6.90278 10.0003 7.10069 10.0802 7.26042 10.2399C7.42014 10.3996 7.5 10.5975 7.5 10.8337C7.5 11.0698 7.42014 11.2677 7.26042 11.4274C7.10069 11.5871 6.90278 11.667 6.66667 11.667ZM13.3333 11.667C13.0972 11.667 12.8993 11.5871 12.7396 11.4274C12.5799 11.2677 12.5 11.0698 12.5 10.8337C12.5 10.5975 12.5799 10.3996 12.7396 10.2399C12.8993 10.0802 13.0972 10.0003 13.3333 10.0003C13.5694 10.0003 13.7674 10.0802 13.9271 10.2399C14.0868 10.3996 14.1667 10.5975 14.1667 10.8337C14.1667 11.0698 14.0868 11.2677 13.9271 11.4274C13.7674 11.5871 13.5694 11.667 13.3333 11.667ZM10 15.0003C9.76389 15.0003 9.56597 14.9205 9.40625 14.7607C9.24653 14.601 9.16667 14.4031 9.16667 14.167C9.16667 13.9309 9.24653 13.733 9.40625 13.5732C9.56597 13.4135 9.76389 13.3337 10 13.3337C10.2361 13.3337 10.434 13.4135 10.5938 13.5732C10.7535 13.733 10.8333 13.9309 10.8333 14.167C10.8333 14.4031 10.7535 14.601 10.5938 14.7607C10.434 14.9205 10.2361 15.0003 10 15.0003ZM6.66667 15.0003C6.43056 15.0003 6.23264 14.9205 6.07292 14.7607C5.91319 14.601 5.83333 14.4031 5.83333 14.167C5.83333 13.9309 5.91319 13.733 6.07292 13.5732C6.23264 13.4135 6.43056 13.3337 6.66667 13.3337C6.90278 13.3337 7.10069 13.4135 7.26042 13.5732C7.42014 13.733 7.5 13.9309 7.5 14.167C7.5 14.4031 7.42014 14.601 7.26042 14.7607C7.10069 14.9205 6.90278 15.0003 6.66667 15.0003ZM13.3333 15.0003C13.0972 15.0003 12.8993 14.9205 12.7396 14.7607C12.5799 14.601 12.5 14.4031 12.5 14.167C12.5 13.9309 12.5799 13.733 12.7396 13.5732C12.8993 13.4135 13.0972 13.3337 13.3333 13.3337C13.5694 13.3337 13.7674 13.4135 13.9271 13.5732C14.0868 13.733 14.1667 13.9309 14.1667 14.167C14.1667 14.4031 14.0868 14.601 13.9271 14.7607C13.7674 14.9205 13.5694 15.0003 13.3333 15.0003Z" fill="#1D1E20" />
                  </g>
                  <defs>
                    <clipPath id="clip0_3974_21253">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              <input
                onFocus={this.calenderDisplay}
                onClick={this.calenderDisplay}
                type="text"
                placeholder="MM/DD/YY"
                maxLength={8}
                name="selectedDate"
                onInput={(e) => {
                  let value = e.currentTarget.value;
                  value = value?.toString()?.replace(/[^0-9\/]+/gi, "");

                  this.handleDateChange(
                    Utils.BuildCustomEventObject("selectedDate", value),
                    6
                  );
                }}
                onBlur={(e) => {
                  let value = e.currentTarget.value;
                  value = value?.toString()?.replace(/[^0-9\/]+/gi, "");

                  this.handleDateChange(
                    Utils.BuildCustomEventObject("selectedDate", value),
                    6,
                    true
                  );
                }}
                autoComplete="selectedDate"
                value={selectedDate}
                className="form-control single-date-pick"
              />
            </div>
            {calenderShow && (
              <div className="calender">
                <OutsideClickHandler onOutsideClick={this.calenderHide}>
                  <Calendar
                    calendarType={"US"}
                    onChange={(date) => {
                      const value = moment(date).format("MM/DD/YY");

                      this.handleDateChange(
                        Utils.BuildCustomEventObject("selectedDate", value),
                        6
                      );
                      this.calenderHide();
                    }}
                    value={
                      selectedDate
                        ? moment(selectedDate)?.format("MM/DD/YY") ===
                          "Invalid date"
                          ? new Date()
                          : new Date(selectedDate)
                        : new Date()
                    }
                    maxDate={
                      this.props?.maxDate
                        ? this.props?.maxDate
                        : new Date(
                            moment().subtract(1, "days").format("MM/DD/YYYYY")
                          )
                    }
                    minDate={null}
                  />
                </OutsideClickHandler>
              </div>
            )}
          </div>
        </button>

        <button onClick={this.handleNextDate} className="btn arrow-right-btn">
          <svg
            width="6"
            height="9"
            viewBox="0 0 6 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.01693 8.414L5.12106 4.207L1.01693 0L6.10352e-05 1.04235L3.08733 4.207L6.10352e-05 7.37165L1.01693 8.414Z"
              fill="#1D1E20"
            />
          </svg>
        </button>
      </div>
    );
  }
}
